import { Box, BoxProps, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export function InfoBalloon({
  children,
  title,
  ...rest
}: {
  children: ReactNode;
  title?: string;
} & BoxProps) {
  return (
    <Box
      w="100%"
      bg="gray.100"
      border={"1px solid var(--chakra-colors-gray-200)"}
      p="4px"
      borderRadius="4px"
      mt="15px"
      {...rest}
    >
      <Box fontSize="12" whiteSpace="pre-wrap">
        {title ? (
          <>
            <Text as="span" fontWeight="bold">
              {title}
            </Text>
            <br />
          </>
        ) : null}

        {children}
      </Box>
    </Box>
  );
}
